'use client'

import { useEffect } from 'react'
import SearchResults from '@/components/assets-explorer/search-results'
import { useSearchStore } from '@/lib/store/search-store'

export const runtime = 'edge'

export default function Page() {
  const query = useSearchStore((state) => state.search)
  const mainCategorySlug = useSearchStore((state) => state.searchMainCategorySlug)

  useEffect(() => {
    console.debug(`Search page loaded with query: ${query} and main category: ${mainCategorySlug}`)
  }, [query, mainCategorySlug])

  return <SearchResults />
}
